import {useSelector} from 'react-redux';
import {Stack} from '@mui/material';

import {ScheduleTrackerIcon} from '@/assets/icons';
import {selectScheduleTrackerRequestsCount} from '@/redux/commonScheduleTracker/selectors';

import {useScheduleTrackerRequestsCounter} from './useScheduleTrackerRequestsCounter';

import styles from './scheduleTrackerRequestsCounter.module.scss';

export const ScheduleTrackerRequestsCounter = ({nurseId}: {nurseId: number}) => {
    const counter = useSelector(selectScheduleTrackerRequestsCount);
    useScheduleTrackerRequestsCounter(nurseId);

    return (
        <Stack position="relative">
            <ScheduleTrackerIcon />
            {counter > 0 && (
                <span className={styles.counter} data-testid="schedule-tracker-requests-counter">
                    {counter}
                </span>
            )}
        </Stack>
    );
};
